import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgFeedback = function SvgFeedback(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_87_25049",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_87_25049)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_87_25049)",
        fillOpacity: 0.16,
        d: "M15.347 15.35Q14 16.698 14 18.614v46.757q0 1.553 1.413 2.138 1.414.586 2.517-.516l4.862-4.863a5 5 0 0 1 3.535-1.464h43.058q1.916 0 3.266-1.35T74 56.051V18.615q0-1.916-1.35-3.266Q71.302 14 69.386 14h-50.77q-1.92 0-3.268 1.35"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_87_25049)",
        d: "M37.147 45h19.904q.548 0 .915-.371.367-.372.367-.927t-.367-.91a1.26 1.26 0 0 0-.915-.356h-17.34zM24.2 45h1.71q.415 0 .808-.208.391-.21.723-.46L46.3 25.66q.435-.372.436-.89 0-.517-.436-.969l-2.275-2.115q-.417-.353-.882-.353t-.817.353L23.615 40.673a4.3 4.3 0 0 0-.458.764 2.05 2.05 0 0 0-.208.89v1.423a1.213 1.213 0 0 0 1.25 1.25M10 61.372V14.615q0-1.916 1.347-3.266T14.615 10h50.77q1.916 0 3.266 1.35Q70 12.698 70 14.614v37.436q0 1.917-1.35 3.266-1.349 1.35-3.265 1.35H20.256l-6.326 6.327q-1.103 1.103-2.517.516Q10 62.925 10 61.372m2.564-.699 6.57-6.57h46.25q.898 0 1.475-.577t.577-1.475V14.615q0-.898-.577-1.474-.577-.577-1.474-.577h-50.77q-.898 0-1.474.577-.577.577-.577 1.474zm0-46.058v-2.05 48.108z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_87_25049",
        x1: 14.627,
        x2: 73.165,
        y1: 40.856,
        y2: 40.856,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_87_25049",
        x1: 10.627,
        x2: 69.165,
        y1: 36.856,
        y2: 36.856,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgFeedback as ReactComponent };
//# sourceMappingURL=Feedback.svg.es.js.map
